import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './Official.css';

class TermsAndConditions extends Component {

    componentDidMount() {
        // Hide loading overlay
        document.getElementById('LoadingOverlay').style.opacity = '0';

        // Update title
        document.title = 'Word Surge - Terms And Conditions';

        // Stop propagation of touchmove on mount
        ReactDOM.findDOMNode(this).addEventListener('touchmove', (e) => {
            e.stopPropagation();
        }, false);
    }

    render() {
        return (
            <div className="OfficialWrapper">
                <div className="OfficialContainer">
                    <h1 className="Title">Terms and Conditions</h1>
                    <p className="Paragraph">
                        Last updated: May 26, 2019
                    </p>
                    <p className="Paragraph">
                        Please read these Terms and Conditions ("Terms", "Terms and Conditions") carefully before using the website or mobile application (the "Service") operated by ("us", "we", or "our").
                    </p>
                    <p className="Paragraph">
                        Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.
                    </p>
                    <p className="Paragraph">
                        By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.
                    </p>
                    <h2 className="Subtitle">Links to Other Websites</h2>
                    <p className="Paragraph">
                        Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.
                    </p>
                    <p className="Paragraph">
                        We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services. You further acknowledge and agree that shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such websites or services.
                    </p>
                    <p className="Paragraph">
                        We strongly advise you to read the terms and conditions and privacy policies of any third-party websites or services that you visit.
                    </p>
                    <h2 className="Subtitle">Termination</h2>
                    <p className="Paragraph">
                        We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                    </p>
                    <p className="Paragraph">
                        All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.
                    </p>
                    <p className="Paragraph">
                        We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.
                    </p>
                    <p className="Paragraph">
                        Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue using the Service.
                    </p>
                    <p className="Paragraph">
                        All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.
                    </p>
                    <h2 className="Subtitle">Governing Law</h2>
                    <p className="Paragraph">
                        These Terms shall be governed and construed in accordance with the laws of United States, without regard to its conflict of law provisions.
                    </p>
                    <p className="Paragraph">
                        Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect.
                    </p>
                    <p className="Paragraph">
                        These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service.
                    </p>
                    <h2 className="Subtitle">In-App Purchases</h2>
                    <p className="Paragraph">
                        While using the app, you will be provided the opportunity to make in-app purchases. These will be made available through the Apple App Store, Google Play Store, and Android App Store. When payment is processed, your data will be collected by the respective App Store and parent company. By completing the purchase, you agree to a complete release of liability of Word Surge and it’s creators/collaborators, including but not limited to: “Aidan Bauer.”
                    </p>
                    <h2 className="Subtitle">Changes</h2>
                    <p className="Paragraph">
                        We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 15 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.
                    </p>
                    <p className="Paragraph">
                        By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.
                    </p>
                    <h2 className="Subtitle">Copyright Information</h2>
                    <p className="Paragraph">
                        Word Surge is the property of Aidan Bauer, the creator and developer of the Service.
                    </p>
                    <p className="Paragraph">
                        By using the Service, you agree to follow all Terms listed above and recognize the data on the Service has been Copyrighted and any breach of Copyright will result in a Copyright infringement warning and potential lawsuit.
                    </p>
                    <h2 className="Subtitle">Contact Us</h2>
                    <p className="Paragraph">
                        If you have any questions about the Terms of Service, please contact us:
                    </p>
                    <ul>
                        <li>
                            By email: contact@aidanbauer.me
                        </li>
                        <li>
                            By visiting this page on our website: http://aidanbauer.me
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

export default TermsAndConditions;
